import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const confirmTypeReview = api(async function confirmTypeReview(id) {
    return mutate(
        gql`
            mutation ConfirmTypeReview($id: String!) {
                confirmTypeReview(id: $id)
            }
        `,
        { id },
        { returns: "confirmTypeReview" }
    )
})
